export default "__VITE_ASSET__CNTHlr5e__"